import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BodyM, BrandL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import { founders, leadershipTeam } from './data.tsx';

const FounderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--quadruple-unit);
  @media ${tabletAndAbove} {
    flex-direction: row;
  }
`;

const PeopleContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  align-items: center;
  justify-items: center;
  gap: var(--quadruple-unit);
  @media ${tabletAndAbove} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${laptopAndAbove} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ImageContainer = styled.div`
  width: 250px;
  height: 350px;
  border-radius: var(--half-unit);
  overflow: hidden;
`;

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: var(--c-nd-100-opaque);

  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.015);
  }
`;

const NoPicture = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--c-nd-100-opaque);
`;

export const Leadership = () => {
  const isLaptop = useIsLaptop();
  return (
    <Container maxWidth={isLaptop ? 800 : 500}>
      <Vertical gap={isLaptop ? 6 : 2} center>
        <BrandL>
          <FormattedMessage
            id="Press.team.title"
            defaultMessage="Meet our leadership team"
          />
        </BrandL>
        <BodyL>
          <FormattedMessage
            id="Press.team.subtitle"
            defaultMessage="We're building something bold, durable, and unlike anything else on the market."
          />
        </BodyL>
        <Vertical gap={5} center>
          <FounderContainer>
            {founders.map(founder => (
              <Vertical key={founder.name}>
                <ImageContainer>
                  <StyledImg src={founder.pictureUrl} alt={founder.name} />
                </ImageContainer>
                <Vertical gap={0}>
                  <BodyL bold>{founder.name}</BodyL>
                  <BodyM>{founder.role}</BodyM>
                </Vertical>
              </Vertical>
            ))}
          </FounderContainer>
          <PeopleContainer>
            {leadershipTeam.map(member => (
              <Vertical key={member.name}>
                <ImageContainer>
                  {member.pictureUrl ? (
                    <StyledImg src={member.pictureUrl} alt={member.name} />
                  ) : (
                    <NoPicture />
                  )}
                </ImageContainer>
                <Vertical gap={0}>
                  <BodyL bold>{member.name}</BodyL>
                  <BodyM>{member.role}</BodyM>
                </Vertical>
              </Vertical>
            ))}
          </PeopleContainer>
        </Vertical>
      </Vertical>
    </Container>
  );
};
